import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PrivacySection = (props: { title: string; description: string; img: string }) => {
  const { title, description, img } = props;
  return (
    <Box>
      <Typography
        variant={"h6"}
        color={""}
        gutterBottom
        sx={{
          fontWeight: "medium",
        }}
      >
        {title}
      </Typography>
      <Typography component={"p"} color={""}>
        {description}
      </Typography>
      <img src={img} className="block max-w-[100%] mt-[10px] mx-auto" alt="" />
    </Box>
  );
};

const Content = () => {
  const data = [
    {
      // title: "1. What information do we collect?",
      description:
        "Capital One Rewards miles provide an excellent avenue for accruing rewards through your daily expenditures. Were you aware that you can leverage these miles by transferring them to airline partners for an array of remarkable award flights? This comprehensive guide will elucidate the process of transferring your Capital One Rewards miles to airline partners and making the most of them for fantastic award flights.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    },
    {
      title: "1. Select Your Airline Partner",
      description:
        "Before you can initiate the transfer of your Capital One miles to an airline partner, it is necessary to decide upon the specific partner to which you intend to transfer your miles. Capital One boasts a diverse array of airline partners, including Air Canada, Emirates, JetBlue, and others.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    },
    {
      // title: "3. Execute the Points Transfer",
      description:
        'To access the complete roster of Capital One airline partners, simply log in to your Capital One account and navigate to the rewards portal. Within the portal, click on the "View Rewards" tab to explore the “Rewards & Benefits” section of your Account Summary page.',
      img: "https://img.awardtool.com/guides/cap1_1_2.jpg",
    },
    {
      // title: "3. Execute the Points Transfer",
      description:
        'In the rewards portal, scroll down and select "Convert rewards". This will display a list of Capital One transfer partners.',
        img: "https://img.awardtool.com/guides/cap1_2-new.png",
    },
    {
      title: "2. Link Your Loyalty Accounts",
      description:
        "Following the selection of your airline partner, the subsequent step involves establishing connections with your loyalty accounts. This encompasses the input of your frequent flyer number for the chosen airline partner. The miles transfer typically operates at a 1:1 ratio or higher. Choose the partner that you'd like to transfer. Enter your frequent flyer account number. Subsequently, your Capital One and Partner accounts will be successfully linked.",
        img: "https://img.awardtool.com/guides/cap1_3.png",
    },
    {
      title: "3. Conduct the Miles Transfer",
      description:
        'After successfully linking your loyalty accounts, the following step is to transfer your Capital One miles to your airline partner. Select the airline partner to which you wish to transfer your miles; for instance, we have chosen Air Canada. Then, indicate the quantity of miles you intend to transfer and click "Continue." The transfer is usually immediate, although in some instances, it may take up to 48 hours.',
      // img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    },
    {
      title: "4. Secure Your Award Flight",
      description:
        "Upon successfully transferring your Capital One miles to your airline partner, the final step involves booking your award flight. To achieve this, log in to your airline loyalty account and initiate a search for available award flights. For expediency, you can employ Award to explore award flights across major airline loyalty programs without the need to visit individual airline websites.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    },

    {
      title: "4. Secure Your Award Flight",
      description:
        "Keep in mind that the availability of award flights can fluctuate, so it is advisable to commence your search well in advance of your intended travel date. It is always prudent to verify your preferred award flight directly through the airline's website before transferring your Capital One Rewards miles, as miles transfers are irreversible.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    },
    // {
    //   // title: "8. How can you review, update or delete the data we collect from you?",
    //   description:
    //     "Keep in mind that the availability of award flights can fluctuate, so it's recommended to conduct your search well in advance of your intended travel date. Additionally, it's always prudent to confirm the desired award flight directly through the airline's website before initiating the transfer of your Chase Ultimate Rewards points, as point transfers are irreversible.",
    //   img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    // },
  ];
  return (
    <Box>
      {data.map((item, i) => (
        <Box key={i} marginBottom={i < data.length - 1 ? 4 : 0}>
          <PrivacySection {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default Content;
